export const PHOTOS_ANIMATION_DURATION = 150;
